import type { ReactNode } from "react";

type PageHeroProps = {
  src: string;
  alt: string;
  children: ReactNode;
  /** Nastavi na false, če slika ni glavna slika nad pregibom. */
  priority?: boolean;
  className?: string;
  /** Dodatni razredi za notranji vsebinski okvir (npr. text-center). */
  innerClassName?: string;
};

/**
 * Hero področje strani z naslovno fotografijo v ozadju (kupish.si).
 * Slika je rahlo zabrisana in prekrita s svetlo plastjo, da ostane besedilo berljivo.
 */
export function PageHero({ src, alt, children, priority = true, className = "", innerClassName = "" }: PageHeroProps) {
  return (
    <header className={`relative overflow-hidden ${className}`}>
      <img
        src={src}
        alt={alt}
        width={1280}
        height={720}
        loading={priority ? "eager" : "lazy"}
        fetchPriority={priority ? "high" : undefined}
        decoding="async"
        className="absolute inset-0 h-full w-full scale-105 object-cover blur-[3px]"
      />
      <div className="absolute inset-0 bg-background/70 md:bg-background/60" aria-hidden="true" />
      <div className={`relative mx-auto max-w-4xl px-6 pt-16 pb-12 md:pt-20 md:pb-16 ${innerClassName}`}>{children}</div>
    </header>
  );
}
